import { create } from 'zustand';
import axios from 'axios';

const useEmployeeDataStore = create((set) => ({
  employeeData: [],
  loading: false,
  error: null,
  showAccessPage403: false,

  getEmployeeData: async (selectedCompany) => {
    const permissions = JSON.parse(localStorage.getItem("userPermissions"));
    const accessToken = localStorage.getItem("accessToken");

    const hasViewPerGroupPermission = permissions?.some(
      (permission) => permission.name === "view_per_group_all_employees_info"
    );
    const hasViewAllManagedPermission = permissions?.some(
      (permission) => permission.name === "view_all_managed_employees_info"
    );

    set({ loading: true, error: null, showAccessPage403: false });

    try {
      let apiUrl = "";
      const timestamp = new Date().getTime();

      if (hasViewPerGroupPermission) {
        apiUrl = `${process.env.REACT_APP_EMP_DATA_COMPANY_URL}=${selectedCompany}&timestamp=${timestamp}`;
      } else if (hasViewAllManagedPermission) {
        apiUrl = `${process.env.REACT_APP_EMP_DATA_MANAGERS_URL}timestamp=${timestamp}`;
      } else {
        set({ showAccessPage403: true, loading: false });
        return;
      }

      const response = await axios.get(apiUrl, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });

      set({
        employeeData: response.data?.data || [],
        loading: false,
      });
    } catch (err) {
      console.error(err);
      set({ error: err.message, loading: false });
    }
  },
}));

export default useEmployeeDataStore;
